export const exportCsvFile = ({
  data,
  fileName,
}: {
  data: string | Blob;
  fileName?: string;
}) => {
  const url = window.URL.createObjectURL(
    typeof data === 'string' ? new Blob([data]) : data
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    `${new Date().toISOString().slice(0, 10)}-${fileName}.csv`
  );
  document.body.append(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
